import { createFileRoute } from "@tanstack/react-router";

import { AddressPage } from "../features/space/AddressPage";

/** The one segment a person is handed: a join code, or a handle for an account's front door. */
export const Route = createFileRoute("/$address")({
  component: AddressRoute,
});

function AddressRoute() {
  const { address } = Route.useParams();
  return <AddressPage address={address} />;
}
